// @flow

const rowGutter = 16
const gutter = 12
const colorYellow = "fc0"
const colorBlue = "008dff"
const colorGreen = "00ba1a"
const colorRed = "f50000"
const colorOrange = "f27a00"
const colorPurple = "800080"
const colorPlaceholderText = "rgba(0, 0, 0, 0.45)"
const colorGray = "747474"

export {
  rowGutter,
  gutter,
  colorYellow,
  colorBlue,
  colorGreen,
  colorRed,
  colorOrange,
  colorGray,
  colorPurple,
  colorPlaceholderText
}
